import { type FC, useEffect } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { Rectangle } from "recharts";

import { type RendererProps } from "../../../models/dimension-funnel";

import { BAR_WIDTH, POLYGON_FILL, funnelMark, xAxisPoints } from "./engagementFunnel.styles";
import { useBarMeasurements } from "./useBarMeasurements";

export const BarWithFunnelLabel: FC<RendererProps> = ({ x, y, width, height, payload, index, radius, fill }) => {
    const { barMeasurements, setBarMeasurements } = useBarMeasurements();

    const showFunnelMarkAndPolygon = !payload?.isMapEmpty && index !== 0;
    const showPolygon = !!index && index !== 0 && !!barMeasurements[index - 1];

    useEffect(() => {
        if (!index) return;
        const currentBar = barMeasurements[index];
        if (!currentBar || currentBar.height !== height) {
            setBarMeasurements({
                ...barMeasurements,
                [index]: {
                    x: xAxisPoints[index] ?? 0,
                    y: y ?? 0,
                    width: width ?? 0,
                    height: height ?? 0,
                },
            });
        }
    }, [setBarMeasurements, barMeasurements, x, y, width, height, index]);

    if (typeof index !== "number") {
        throw new TypeError("Missing bar index.");
    }

    return (
        <>
            <Rectangle x={xAxisPoints[index]} y={y} fill={fill} radius={radius} width={width} height={height} />
            {showPolygon && (
                <polygon
                    fill={POLYGON_FILL}
                    points={`
                        ${(xAxisPoints[index - 1] ?? 0) + BAR_WIDTH},${barMeasurements[index - 1]?.y}
                        ${(xAxisPoints[index - 1] ?? 0) + BAR_WIDTH},${
                            (barMeasurements[index - 1]?.y ?? 0) + (barMeasurements[index - 1]?.height ?? 0)
                        }
                        ${xAxisPoints[index]},${(y ?? 0) + (height ?? 0)}
                        ${xAxisPoints[index]},${y}
                    `}
                />
            )}
            {showFunnelMarkAndPolygon && (
                <>
                    <g transform={`translate(${(xAxisPoints[index] ?? 0) - 110} 360)`} fill={Colors.Gray.V300}>
                        <path d="M0.89209 2C0.89209 0.895431 1.78752 0 2.89209 0H69.2616C69.8702 0 70.4458 0.277184 70.8253 0.753081L80.3942 12.7531C80.9759 13.4826 80.9759 14.5174 80.3942 15.2469L70.8253 27.2469C70.4458 27.7228 69.8702 28 69.2616 28H2.89209C1.78752 28 0.89209 27.1046 0.89209 26V2Z" />
                    </g>
                    <text y="377.5" x={(xAxisPoints[index] ?? 0) - 110 + 8} className={funnelMark}>
                        {payload?.fractionFromPreviousPercentFormatted}
                    </text>
                </>
            )}
        </>
    );
};
